// #region imports

// --- Angular
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

// --- Hs Code
import {
  SurveyResponseModel,
  SurveyResponseTypes,
  SurveyStatuses,
  ScoreModel,
  ResultsViews,
  ResultsStatuses,
  SurveySummaryModel
} from '../../../models';

// #endregion

@Component({
  selector: 'hs-results-shell',
  templateUrl: './results-shell.component.html',
  styleUrls: ['./results-shell.component.scss']
})
export class ResultsShellComponent implements OnInit {
  @Input() surveyResponse: SurveySummaryModel | null = null;
  @Input() responseType: SurveyResponseTypes = SurveyResponseTypes.unknown;
  @Input() scores: ScoreModel[][] | null = null;
  @Input() resultsDisplayMode: ResultsViews | null = null;
  @Input() resultsStatus: ResultsStatuses = ResultsStatuses.surveyIncomplete;
  @Input() reportReleaseDate: Date | null = null;
  @Input() isLocked: boolean = false;
  @Input() hideLockContent: boolean = false;
  @Input() imagesRootUrl: string = '';

  @Output() chartClicked = new EventEmitter();

  title: string = '';

  responseTypes = SurveyResponseTypes;
  responseStatuses = SurveyStatuses;

  ngOnInit() {
    switch (this.responseType) {
      case SurveyResponseTypes.benchmark:
        this.title = 'surveyQuestionsBenchmark';
        break;
      case SurveyResponseTypes.other:
        this.title = 'resultsScoreOthers';
        break;
      default:
        this.title = 'surveyQuestionsSelfScore';
        break;
    }

  }

  onChartClick() {
    this.chartClicked.emit();
  }
}
